import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withRouter } from 'react-router-dom';

import SignUpForm from '../components/SignUpForm';
import PurchaseSummary from '../components/PurchaseSummary';
import Loader from '../components/Loader';
import HeaderLoggedOut from '../components/HeaderLoggedOut';
import signupAuth from '../services/auth/signupAuth';
import signinAuth from '../services/auth/signinAuth';

const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '100%',
  }),
  root: {
    paddingLeft: 10,
    paddingRight: 10,
    width: 600,
    margin: 'auto',
  },
  grid: {
    margin: 0,
    marginTop: theme.spacing.unit * 5,
  },
  title: {
    color: '#424242',
  },
  subTitle: {
    paddingBottom: 5,
  },
});

class SignUp extends Component {
  state = {
    isLoading: false,
    fullName: '',
    email: '',
    password: '',
    confirmPassword: '',
    userType: 'customer',
    accountId: '',
    phoneNumber: '',
    newUser: null,
    teamPhoneNumber: '',
    selectedPlan: '',
    shippingCharge: 15,
  };

  validateForm = () => {
    return (
      this.state.email.length > 3 &&
      this.state.email.includes('@') &&
      validatePassword(this.state.password, this.state.confirmPassword) &&
      formatNumber(this.state.phoneNumber).length === 10 &&
      this.state.fullName.length > 2
    );
  };

  handleChange = event => {
    let email = '';
    if (event.target.id === 'email') {
      email = event.target.value.toLowerCase();
      this.setState({
        email,
      });
    } else {
      this.setState({
        [event.target.id]: event.target.value,
      });
    }
  };

  handleSubmit = async event => {
    event.preventDefault();
    this.setState({ isLoading: true });
    const user = {
      email: this.state.email,
      password: this.state.password,
      name: this.state.fullName,
      phoneNumber: `+1${formatNumber(this.state.phoneNumber)}`,
    };
    try {
      const newUser = await signupAuth(user);
      if (newUser) {
        await signinAuth(user);
      }
      this.props.userHasAuthenticated(true);

      this.props.history.push('/checkout', {
        plan: getPlanDetails(
          this.props.match.params.plan,
          this.state.shippingCharge
        ),
        email: user.email,
        name: user.name,
        userName: newUser.userSub,
        phoneNumber: user.phoneNumber,
      });
    } catch (e) {
      alert(e.message);
    }
  };

  render() {
    const { classes, match } = this.props;
    const plan = getPlanDetails(match.params.plan, this.state.shippingCharge);
    const props = {
      handleChange: this.handleChange,
      handleSubmit: this.handleSubmit,
      validateForm: this.validateForm,
      phoneNumber: this.state.phoneNumber,
    };
    const { isLoading } = this.state;
    return (
      <div className={classes.root}>
        <HeaderLoggedOut signin={true} />
        <Grid
          className={classes.grid}
          container
          spacing={24}
          justify="center"
          direction="row"
        >
          <Grid item xs={12} md={7} lg={7}>
            <Paper className={classes.paper} elevation={4}>
              {isLoading ? (
                <Loader loaderText="Signing Up..." />
              ) : (
                <div>
                  <Typography variant="title" className={classes.title}>
                    Account Details
                  </Typography>
                  <Typography paragraph={true} color="textSecondary">
                    * All fields are required.
                  </Typography>
                  <SignUpForm {...props} />
                </div>
              )}
            </Paper>
          </Grid>
          <Grid item xs={12} md={5} lg={5}>
            <PurchaseSummary summary={plan} />
          </Grid>
        </Grid>
      </div>
    );
  }
}

function formatNumber(numText) {
  const validDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  const formatted = numText
    .split('')
    .filter(char => {
      return validDigits.includes(char);
    })
    .join('');
  return formatted;
}

function getPlanDetails(planStr, shipping) {
  const details = planStr.split('-');
  const plan = {
    price: parseInt(details[1], 10),
    name: details[0],
    id: details[2],
    shipping,
  };
  plan.total = plan.price + shipping;
  return plan;
}

function validatePassword(pw, confirmPw) {
  const basic = pw.length >= 8 && pw === confirmPw;
  const strong = new RegExp(
    '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})'
  );

  return basic && strong.test(pw);
}

export default withRouter(withStyles(styles)(SignUp));



// WEBPACK FOOTER //
// ./src/containers/SignUp.js